/*
 * Copyright, AlpineReplay, Inc. 2021. All rights reserved.
 * Author: Brian Bal
 */
import { webApi } from '../../lib/WebApi'

const loadTeamStaff = (teamId) => {
    return (dispatch, getState) => {

        const ts = getState().team_staff
        const ds = getState().division_staff

        if (ts.loading) {
            return { type: 'NOOP' }
        }
        if (ts.complete && ts.value.team_id === teamId && ts.needs_reload !== true) {
            return { type: 'NOOP' }
        }
        if (!ds.complete || !ds.value || !ds.value.staff || ds.value.staff.length === 0) {
            console.log('loadTeamStaff', ds.value)
            return { type: 'NOOP' }
        }

        dispatch({
            type: 'COMMON_SET',
            key: 'team_staff',
            value: {
                needs_reload: false,
                loading: true,
                value: ts.value,
                error: null
            }
        })

        webApi.getTeamUsers(teamId)
            .then(users => {
                for (let usr of users) {
                    usr.full_name = `${usr.user.first_name} ${usr.user.last_name}`
                }

                console.log("loadTeamStaff", "merging division staff", ds.value.staff)
                for (let dm of ds.value.staff) {
                    let isMember = false
                    for (let tm of users) {
                        if (dm.user_id === tm.user_id) {
                            isMember = true
                        }
                    }

                    console.log("loadTeamStaff", dm.user_id, isMember)
                    if (!isMember) {
                        // add a placeholder member
                        let member = {
                            team_id: teamId,
                            user_id: dm.user_id,
                            full_name: dm.full_name,
                            join_time: null,
                            leave_time:null,
                            is_active: '1',
                            is_player: '0',
                            is_videographer: '0',
                            is_coach: '0',
                            position: '',
                            jersey_number: '',
                            default_trace_number: '0',
                            invite_status: 'none',
                            invite_status_update_time:null,
                            team_id: teamId,
                            user: dm,
                            filled_from_division_staff: true
                        }
                        console.log("loadTeamStaff", "fill", dm, member)
                        users.push(member)
                    }
                }


                dispatch({
                    type: 'COMMON_SET',
                    key: 'team_staff',
                    value: {
                        needs_reload: false,
                        loading: false,
                        complete: true,
                        error: null,
                        value: {
                            team_id: teamId,
                            staff: users,
                        }
                    }
                })
            })
            .catch(e => {
                dispatch({
                    type: 'COMMON_SET',
                    key: 'team_staff',
                    value: {
                        loading: false,
                        complete: true,
                        error: e,
                        value: {
                            team_id: teamId,
                            staff: [],
                        }
                    }
                })
            })



    }
}

export default loadTeamStaff
